module.exports = __webpack_public_path__ + "img/elementwidths_jasa.e1ed260a.png";